import React from 'react'
import { GroundMapper } from './GroundMapper'
import PlayTitle from './PlayTitle'

const RightContentMap = () => {
    return (
        <div className='md:fixed md:top-[156px] md:right-5 md:w-1/4'>
            <div className='text-xl text-gray-500 dark:text-cDarkText2 font-semibold tracking-widest w-full text-center pb-2 drop-shadow-md uppercase'>Ground Map</div>
            <div className='flex flex-col space-y-3'>
                {GroundMapper?.map((item, index) =>
                    <PlayTitle
                        capsule={true}
                        key={index}
                        title={item?.title}
                        subtitle={item?.subtitle}
                        linkTo={item?.linkTo}
                    />
                )}
            </div>
        </div>
    )
}

export default RightContentMap